var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReloadai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_1039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 15C9.17 15 11.12 14.01 12.4 12.45C12.58 12.24 12.55 11.92 12.33 11.75C12.28 11.71 12.23 11.69 12.18 11.67C11.99 11.6 11.76 11.65 11.63 11.82C10.53 13.15 8.87 14 7 14C5.34 14 3.84 13.33 2.76 12.24C1.67 11.15 1 9.66 1 8C1 6.34 1.67 4.84 2.76 3.76C3.85 2.67 5.34 2 7 2C8.66 2 10.16 2.67 11.24 3.76C11.87 4.39 12.36 5.17 12.66 6.03L11.41 6.07C11.04 6.08 10.82 6.51 11.02 6.84L12.85 9.81L13.15 10.3C13.35 10.62 13.79 10.6 13.97 10.27L15.88 6.68C16.06 6.34 15.82 5.92 15.45 5.94L13.7 5.99C12.84 3.1 10.16 1 7 1C3.13 1 0 4.13 0 8C0 11.87 3.13 15 7 15Z",
    fill: "#FAA500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_1039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadai);
export default __webpack_public_path__ + "static/media/reloadai.0414157dc74b640b708c622da58ac0d0.svg";
export { ForwardRef as ReactComponent };